import { render, staticRenderFns } from "./ChooseGuige.vue?vue&type=template&id=1d6f7187&scoped=true"
import script from "./ChooseGuige.vue?vue&type=script&lang=js"
export * from "./ChooseGuige.vue?vue&type=script&lang=js"
import style0 from "./ChooseGuige.vue?vue&type=style&index=0&id=1d6f7187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6f7187",
  null
  
)

export default component.exports